module.exports = "/_next/static/media/4489646805ac1fe80a0f47e2745596fc.svg";